import { groupBy } from "../../utils";
import { z } from "zod";
export const DesignElementSnapshotReason = z.enum(["Publish", "Deletion"]);
export const DesignElementSnapshotBase = z.object({
    id: z.string(),
    persistentId: z.string(),
    designSystemVersionId: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    reason: DesignElementSnapshotReason,
    createdByUserId: z.string(),
});
//
// Util functions
//
export function pickLatestSnapshots(snapshots, getSnapshotElementId) {
    const groupedSnapshots = groupBy(snapshots, getSnapshotElementId);
    return Array.from(groupedSnapshots.entries()).map(([_, snapshots]) => {
        // Sort snapshots by created at date desc
        const sorted = snapshots.sort((lhs, rhs) => rhs.createdAt.getTime() - lhs.createdAt.getTime());
        return sorted[0];
    });
}
